import { render, staticRenderFns } from "./AddSecondaryScraper.vue?vue&type=template&id=2bba8512&"
import script from "./AddSecondaryScraper.vue?vue&type=script&lang=js&"
export * from "./AddSecondaryScraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports